module.exports = __webpack_public_path__ + "img/icon_tjhby.f3a6d10d.png";